import { render, staticRenderFns } from "./CompanyVision.vue?vue&type=template&id=40bf3410&"
import script from "./CompanyVision.vue?vue&type=script&lang=js&"
export * from "./CompanyVision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports